import React, { useState } from "react";
import style from "./style.module.scss";
import { formatCurrency } from "../../../../../../components/helper/helper";
import CaretRight from "../../../../../assets/svg/icons/common/CaretRight";

const CARD_IMAGES = {
  VS: "/images/visa24x24.svg",
  MC: "/images/master24x24.svg",
  DS: "/images/discover24x24.svg",
  AM: "/images/amex24x24.svg",
};

const Row = ({ data }) => {
  const [open, setOpen] = useState(false);
  const children = Array.isArray(data?.children) ? data.children : [];
  const hasChildren = children.length > 0;

  return (
    <>
      <tr className={style.table_row}>
        <td className={style.table_cell}>
          <div className={style.card_brand_cell}>
            {hasChildren ? (
              <button
                type="button"
                className={`${style.expand_button} ${open ? style.rotated : ""}`}
                onClick={() => setOpen((v) => !v)}
                aria-label={open ? "Collapse" : "Expand"}
              >
                <CaretRight />
              </button>
            ) : (
              <span className={style.expand_button} aria-hidden />
            )}
            {CARD_IMAGES[data?.card_brand] && (
              <img
                src={CARD_IMAGES[data?.card_brand]}
                alt={data?.card_brand}
                className={style.card_icon}
              />
            )}
            <span>{data?.card_brand}</span>
          </div>
        </td>
        <td className={style.table_cell} />
        <td className={style.table_cell}>{data?.num || "-"}</td>
        <td className={style.table_cell}>
          {data?.amount ? `$ ${formatCurrency(data.amount)}` : "-"}
        </td>
        <td className={style.table_cell}>$ {formatCurrency(data?.income)}</td>
        <td className={style.table_cell}>$ {formatCurrency(data?.expense)}</td>
      </tr>
      {open &&
        children.map((c, i) => (
          <tr key={i} className={style.child_row}>
            <td className={style.child_cell} />
            <td className={style.child_cell}>{c.descript || "-"}</td>
            <td className={style.child_cell}>{c.num || "-"}</td>
            <td className={style.child_cell}>
              {c.amount ? `$ ${formatCurrency(c.amount)}` : "-"}
            </td>
            <td className={style.child_cell}>$ {formatCurrency(c.income)}</td>
            <td className={style.child_cell}>$ {formatCurrency(c.expense)}</td>
          </tr>
        ))}
    </>
  );
};

export default Row;
